import { render, staticRenderFns } from "./MainReport.vue?vue&type=template&id=280f9ee8&"
import script from "./MainReport.vue?vue&type=script&lang=js&"
export * from "./MainReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports